// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-tournament-section-card__section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space);
}

.hub-tournament-section-card__cards-container {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(8, 1fr);

    position: relative;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    overflow-y: hidden;
}

.hub-tournament-section-card__cards-container.hub-tournament-section-card__cards-container__subsection {
    grid-template-columns: repeat(3, 1fr);
}

.hub-tournament-section-card__cards-container.long-view {
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(5, 1fr);
    grid-auto-flow: column;
}

.hub-tournament-section-card__cards-container.follow-view {
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: column;
}

.hub-tournament-section-card__container {
    margin-bottom: var(--space-x2);
}

.hub-tournament-section-card__section .baloa-normal-medium {
    color: var(--new-green-color);
    cursor: pointer;
}

.hub-tournament-section-card__section__subsection-title {
    display: flex;
    align-items: center;
    background-color: var(--white-color);
    padding: var(--space-x3);

}

.hub-tournament-section-card__section__subsection-title .icon-arrow-left {
    font-size: var(--space-and-half);
    margin-right: var(--space);
    cursor: pointer;
}

.hub-tournament-section-card__section__subsection-arrow{
    position: relative;
    top: 53%;
    cursor: pointer;
    z-index: 9;
    border-radius: 50%;
}

.hub-tournament-section-card__section__subsection-arrow.prev{
    float: left;
    top: 188px;
    margin: -20px;
}

.hub-tournament-section-card__section__subsection-arrow.prev.follow-view {
    top: 148px;
}

.hub-tournament-section-card__section__subsection-arrow.prev .hubicon-arrow_circle_left{
    font-size: 40px;
}

.hub-tournament-section-card__section__subsection-arrow.next{
    right: 0;
    float: right;
    top: 168px;
    margin-right: -40px;
}

.hub-tournament-section-card__section__subsection-arrow.next.follow-view{
    top: 128px;
}

.hub-tournament-section-card__section__subsection-arrow.next .hubicon-arrow_circle_right{
    font-size: 40px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .hub-tournament-section-card__cards-container {
        gap: 0;
        grid-template-columns: repeat(1, 1fr);
        display: block;
        overflow-x: scroll;
    }

    .hub-tournament-section-card__section {
        margin-top: var(--space);
        margin-left: 8px;
        margin-right: 8px;
        
    }

    .hub-tournament-section-card__cards-container.long-view {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(8, 1fr);
        grid-template-rows: repeat(1, 1fr);
        grid-auto-flow: row;
        padding-bottom: 4px;
        padding-left: 10px;
    }

    .hub-tournament-section__title.baloa-headline-2{
        margin-left: 8px;
    }

    .hub-tournament-section-card__cards-container.follow-view {
        display: grid;
        gap: 4px;
        grid-template-columns: repeat(2, 1fr);
        /* grid-template-rows: repeat(2, 1fr); */
        grid-row-start: 1;
        grid-row-end: 3;
        grid-column-start: 1;
        grid-column-end: 3;
        grid-auto-flow: column;
        padding-bottom: 4px;
        padding-left: 10px;
    }
 }`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-tournament-section-card/HubTournamentSectionCardComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qCAAqC;;IAErC,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,wBAAwB;;AAE5B;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,MAAM;QACN,qCAAqC;QACrC,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,gBAAgB;QAChB,iBAAiB;;IAErB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,qCAAqC;QACrC,kCAAkC;QAClC,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,qCAAqC;QACrC,wCAAwC;QACxC,iBAAiB;QACjB,eAAe;QACf,oBAAoB;QACpB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;CACH","sourcesContent":[".hub-tournament-section-card__section {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: var(--space);\n}\n\n.hub-tournament-section-card__cards-container {\n    display: grid;\n    gap: 16px;\n    grid-template-columns: repeat(8, 1fr);\n\n    position: relative;\n    overflow-x: hidden;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n}\n\n.hub-tournament-section-card__cards-container.hub-tournament-section-card__cards-container__subsection {\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.hub-tournament-section-card__cards-container.long-view {\n    grid-template-rows: repeat(2, 1fr);\n    grid-template-columns: repeat(5, 1fr);\n    grid-auto-flow: column;\n}\n\n.hub-tournament-section-card__cards-container.follow-view {\n    grid-template-rows: repeat(2, 1fr);\n    grid-template-columns: repeat(3, 1fr);\n    grid-auto-flow: column;\n}\n\n.hub-tournament-section-card__container {\n    margin-bottom: var(--space-x2);\n}\n\n.hub-tournament-section-card__section .baloa-normal-medium {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.hub-tournament-section-card__section__subsection-title {\n    display: flex;\n    align-items: center;\n    background-color: var(--white-color);\n    padding: var(--space-x3);\n\n}\n\n.hub-tournament-section-card__section__subsection-title .icon-arrow-left {\n    font-size: var(--space-and-half);\n    margin-right: var(--space);\n    cursor: pointer;\n}\n\n.hub-tournament-section-card__section__subsection-arrow{\n    position: relative;\n    top: 53%;\n    cursor: pointer;\n    z-index: 9;\n    border-radius: 50%;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.prev{\n    float: left;\n    top: 188px;\n    margin: -20px;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.prev.follow-view {\n    top: 148px;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.prev .hubicon-arrow_circle_left{\n    font-size: 40px;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.next{\n    right: 0;\n    float: right;\n    top: 168px;\n    margin-right: -40px;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.next.follow-view{\n    top: 128px;\n}\n\n.hub-tournament-section-card__section__subsection-arrow.next .hubicon-arrow_circle_right{\n    font-size: 40px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .hub-tournament-section-card__cards-container {\n        gap: 0;\n        grid-template-columns: repeat(1, 1fr);\n        display: block;\n        overflow-x: scroll;\n    }\n\n    .hub-tournament-section-card__section {\n        margin-top: var(--space);\n        margin-left: 8px;\n        margin-right: 8px;\n        \n    }\n\n    .hub-tournament-section-card__cards-container.long-view {\n        display: grid;\n        gap: 8px;\n        grid-template-columns: repeat(8, 1fr);\n        grid-template-rows: repeat(1, 1fr);\n        grid-auto-flow: row;\n        padding-bottom: 4px;\n        padding-left: 10px;\n    }\n\n    .hub-tournament-section__title.baloa-headline-2{\n        margin-left: 8px;\n    }\n\n    .hub-tournament-section-card__cards-container.follow-view {\n        display: grid;\n        gap: 4px;\n        grid-template-columns: repeat(2, 1fr);\n        /* grid-template-rows: repeat(2, 1fr); */\n        grid-row-start: 1;\n        grid-row-end: 3;\n        grid-column-start: 1;\n        grid-column-end: 3;\n        grid-auto-flow: column;\n        padding-bottom: 4px;\n        padding-left: 10px;\n    }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
